import BankAccounts from "../features/finance/BankAccounts";

const BankAccountsPage = () => {
    return <BankAccounts />;
};

export default BankAccountsPage;
